import React from 'react';
import { useTranslation } from 'react-i18next';
import Markdown from '../common/Markdown';

const trimOrEmpty = (v) => String(v || '').trim();

function Block({ title, children }) {
  if (!children) return null;
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-3">
      <div className="text-xs font-extrabold uppercase tracking-wide text-gray-600">{title}</div>
      <Markdown className="mt-2 text-sm text-gray-800 leading-relaxed [&_p]:my-2 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_li]:my-1">
        {children}
      </Markdown>
    </div>
  );
}

export default function WorkoutEnrichmentBlocks({ workout, className = '' }) {
  const { t } = useTranslation();

  const why = trimOrEmpty(workout?.why);
  const fueling = trimOrEmpty(workout?.fueling);
  const technique = trimOrEmpty(workout?.technique);

  if (!why && !fueling && !technique) return null;

  return (
    <div className={['space-y-2', className].filter(Boolean).join(' ')}>
      {why ? <Block title={t('workout.enrichment.why')}>{why}</Block> : null}
      {fueling ? <Block title={t('workout.enrichment.fueling')}>{fueling}</Block> : null}
      {technique ? <Block title={t('workout.enrichment.technique')}>{technique}</Block> : null}
    </div>
  );
}

